// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxbeth } from "../../../icons/full/build/icon-axbeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxbethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxbeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxbethIcon.displayName = 'AxbethIcon';
}

export default AxbethIcon;